import { Stack, Typography, useTheme } from "@mui/material";
import { Star } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const AdvisorMainBadge: FC = () => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.xs}
			px={theme.spacingTokens.sm}
			py={theme.spacingTokens.xs}
			bgcolor={theme.palette.amber[50]}
			borderRadius={theme.shape.pillRadius}
		>
			<Star
				size={theme.iconSize.xs}
				fill={theme.palette.amber[400]}
				color={theme.palette.amber[400]}
			/>
			<Typography variant="caption" color={theme.palette.amber[600]}>
				{t(Resources.Advisor.mainBadge)}
			</Typography>
		</Stack>
	);
};
